import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { docsOpe } from "src/app/models/docsOpe";
import { environment } from "src/environments/environment";
import { vignetteOpe } from "src/app/models/vignetteOpe"
import { Doc } from "src/domain/doc";
@Injectable({
    providedIn: 'root'
  })
  export class DocServices {
    getDocuments() {
      throw new Error('Method not implemented.');
    }
    numOpe!: number;

    BASE_PATH_OPE_DOCS= "/docs/ope-doc/";
    BASE_PATH_DOCS_VT= "/docs_vt";
    BASE_PATH_VIGNETTE_FIRST="/firstvignette";
    BASE_PATH_VIGNETTE="/vignettes";
    BASE_PATH_DOCS_VT_FILE="/docs/ope-doc/docs_vt_file/";
    constructor(private readonly http: HttpClient) {}

    getDocumentsBynumOpe(data: number): Observable<Doc>{
    const url = environment.host.domaine;
    return this.http.get<Doc>(url+this.BASE_PATH_OPE_DOCS+data+this.BASE_PATH_DOCS_VT);
    }

    getVignetteBynumOpe(data: number): Observable<vignetteOpe[]>{
      const url = environment.host.domaine;
      return this.http.get<vignetteOpe[]>(url+this.BASE_PATH_OPE_DOCS+data+this.BASE_PATH_VIGNETTE);
    }

    getFirVignetteBynumOpe(data: number): Observable<vignetteOpe>{
      const url = environment.host.domaine;
      return this.http.get<vignetteOpe>(url+this.BASE_PATH_OPE_DOCS+data+this.BASE_PATH_VIGNETTE_FIRST);
    }

    downloadDocumentsbyCode(code:number): Observable<Doc>{
      const url = environment.host.domaine;
      return this.http.get<Doc>(url+this.BASE_PATH_DOCS_VT_FILE+code);

    }
  }
